import React, { Component } from 'react';
 class ShowPopup extends Component {
     constructor(props){
         super(props);
         this.state={
            isHide:true,
         }
         this.hidePopUp= this.hidePopUp.bind(this);
     }
     hidePopUp(){
       this.setState({
           isHide:false
       })
     }
    render() {
        return (
            <div className="popup-section">
                {this.state.isHide?
                    <div className="popup-container">
                        <h2 onClick={this.hidePopUp}>X</h2>
                        <div className="success-popup">
                            <img src="../img/check.svg"/>
                            <p>Your response has been recorded. We will get back to you soon</p>
                        </div>
                    </div>
                :null}
            </div>
        )
    }
}


export default ShowPopup;



// WEBPACK FOOTER //
// ./src/components/ShowPopup/ShowPopup.js